import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { HeaderView } from 'src/app/shared/header.view';
import { UserInfoView } from './parts/userinfo-form.view';
import { UserSettingsView } from './parts/usersettings-form.view';
import { UserCredentialsView } from './parts/usercredentials-form.view';

interface Props extends ComponentViewProps<UserItem> {
	title: string;
	save: () => void;
	cancel: () => void;
	mode: ControlMode;
	isAdministrator: boolean;
	operation: 'new' | 'update';
	roles: DataSet<UserRoleSummary>;
	createNewUserRole: (roleId: number) => Promise<UserRoleSummary>;
	onCancel: () => Promise<any>;
	onModeChanged: (mode: ControlMode) => void;
	onAvatarChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;
	contextService: { isDirty: boolean; };
}

@observer
export class UserFormView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const {
			title, save, cancel, onModeChanged, mode, model,
			setBusy, operation, isAdministrator, onAvatarChange,
			contextService
		} = this.props;
		if (model == null) {
			return null;
		}

		return (
			<div className="window window-normal">
				<Prompt
					when={contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 3, span: 18 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChanged}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={contextService}
								/>
							</Col>
						</Row>
						<div className="card card-borderless">
							<UserInfoView
								model={model}
								mode={mode}
								isAdministrator={isAdministrator}
								onAvatarChange={onAvatarChange}
								setBusy={setBusy}
								createNewUserRole={this.props.createNewUserRole}
								roles={this.props.roles}
								{...this.props}
							/>
							<Row gutter={16}>
								<Col xs={24} lg={16}>
									<UserSettingsView
										model={model}
										mode={mode}
										setBusy={setBusy}
									/>
								</Col>
								<Col xs={24} lg={8}>
									{
										mode === 'edit' &&
										<UserCredentialsView
											model={model}
											mode={mode}
											operation={operation}
											setBusy={setBusy}
										/>
									}
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/users/form/user-form.view.tsx